/* eslint-disable import/order */
// This must be first import of whole application
import '#/lib/monitoringDebug';

// Initialize ASAP to track start Web Vitals tracking
import '#/lib/analyticsPosthogSetup';

// required for css prop use <div css={css``} /> - removed from bundle
// https://styled-components.com/docs/api#css-prop
// import type {} from 'styled-components/cssprop';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { QueryClientProviderAndHandlers } from '#/api/queryClient';
import AppEntry from '#/components/AppEntry';
import { ReduxProvider } from '#/reduxState/storeSetup';

import { loadTranslations } from './translations';

import 'normalize.css';
import './style.css';
import '#/components/auth/Captcha/captchaGlobalStyle.css';
import '#/lib/ethereum/wallets/walletConnectV2.css';

// import * as serviceWorker from './serviceWorker';

// initializeErrorMonitoring(APP_VERSION);

loadTranslations();

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);

  root.render(
    <StrictMode>
      <ReduxProvider>
        <Suspense fallback={<div />}>
          {/* <HelmetProvider> */}
          <QueryClientProviderAndHandlers>
            <AppEntry />
          </QueryClientProviderAndHandlers>
        </Suspense>
      </ReduxProvider>
    </StrictMode>
  );
}
